"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArgMap = exports.getArgArray = exports.getArgDate = exports.getArgDateOrUndefined = exports.getArgBoolean = exports.getArgNumber = exports.getArgNumberOrUndefined = exports.getArgStringStrict = exports.getArgString = exports.getArgStringOrUndefined = exports.getArgUnknownOrUndefined = exports.getArgUnknown = exports.errMsg = exports.argDetails = void 0;
const dateFns = __importStar(require("date-fns"));
const __1 = require("..");
const dates_1 = require("./dates");
const to_ordinal_1 = require("./to-ordinal");
const isType = {
    string: (value) => typeof value === "string",
    number: (value) => typeof value === "number" && !Number.isNaN(value),
    boolean: (value) => typeof value === "boolean",
    date: (value) => value instanceof Date,
    array: (value) => Array.isArray(value),
};
const argDetails = (value) => {
    if (typeof value === "object") {
        if (Array.isArray(value)) {
            return ["[]", "list"];
        }
        else {
            return ["{}", "object"];
        }
    }
    return [String(value), typeof value];
};
exports.argDetails = argDetails;
const errMsg = (argPosition, expectedType, received) => {
    const [representation, type] = (0, exports.argDetails)(received);
    return `Expected the ${(0, to_ordinal_1.toOrdinal)(argPosition)} arg to be a ${expectedType}, instead "${representation}" was received which is of type ${type}`;
};
exports.errMsg = errMsg;
const getArgUnknown = (args, argPosition, context) => {
    const argExp = args[argPosition - 1];
    if (argExp === undefined) {
        throw new Error((0, exports.errMsg)(argPosition, "string", undefined));
    }
    return (0, __1.execSyntax)(argExp, context);
};
exports.getArgUnknown = getArgUnknown;
const getArgUnknownOrUndefined = (args, argPosition, context) => {
    const argExp = args[argPosition - 1];
    if (!argExp) {
        return undefined;
    }
    return (0, __1.execSyntax)(argExp, context);
};
exports.getArgUnknownOrUndefined = getArgUnknownOrUndefined;
const getArgStringOrUndefined = (args, argPosition, context) => {
    const value = (0, exports.getArgUnknownOrUndefined)(args, argPosition, context);
    if (isType.string(value) || value === undefined) {
        return value;
    }
    if (isType.number(value) || isType.boolean(value)) {
        return value.toString();
    }
    if (isType.date(value)) {
        return value.toISOString().substring(0, 10);
    }
    throw new Error((0, exports.errMsg)(argPosition, "string or undefined", value));
};
exports.getArgStringOrUndefined = getArgStringOrUndefined;
const getArgString = (args, argPosition, context) => {
    const value = (0, exports.getArgUnknown)(args, argPosition, context);
    if (isType.string(value)) {
        return value;
    }
    if (isType.number(value) || isType.boolean(value)) {
        return value.toString();
    }
    if (isType.date(value)) {
        return value.toISOString().substring(0, 10);
    }
    throw new Error((0, exports.errMsg)(argPosition, "string", value));
};
exports.getArgString = getArgString;
const getArgStringStrict = (args, argPosition, context) => {
    const value = (0, exports.getArgUnknown)(args, argPosition, context);
    if (isType.string(value)) {
        return value;
    }
    throw new Error((0, exports.errMsg)(argPosition, "string", value));
};
exports.getArgStringStrict = getArgStringStrict;
const getArgNumberOrUndefined = (args, argPosition, context) => {
    const value = (0, exports.getArgUnknownOrUndefined)(args, argPosition, context);
    if (isType.number(value) || value === undefined) {
        return value;
    }
    if (value === "") {
        return undefined;
    }
    if (isType.string(value) || isType.boolean(value)) {
        const num = Number(value);
        if (!Number.isNaN(num)) {
            return num;
        }
        return undefined;
    }
    throw new Error((0, exports.errMsg)(argPosition, "number or undefined", value));
};
exports.getArgNumberOrUndefined = getArgNumberOrUndefined;
const getArgNumber = (args, argPosition, context) => {
    const value = (0, exports.getArgUnknown)(args, argPosition, context);
    if (isType.number(value)) {
        return value;
    }
    if ((isType.string(value) && value !== "") || isType.boolean(value)) {
        const num = Number(value);
        if (!Number.isNaN(num)) {
            return num;
        }
    }
    throw new Error((0, exports.errMsg)(argPosition, "number", value));
};
exports.getArgNumber = getArgNumber;
const getArgBoolean = (args, argPosition, context) => {
    const value = (0, exports.getArgUnknown)(args, argPosition, context);
    if (isType.boolean(value)) {
        return value;
    }
    if (isType.string(value) || isType.number(value) || isType.date(value)) {
        return Boolean(value);
    }
    throw new Error((0, exports.errMsg)(argPosition, "boolean", value));
};
exports.getArgBoolean = getArgBoolean;
const getArgDateOrUndefined = (args, argPosition, context) => {
    const value = (0, exports.getArgUnknownOrUndefined)(args, argPosition, context);
    if (isType.date(value) || value === undefined) {
        return value;
    }
    if (isType.string(value)) {
        if (dates_1.reMMDDYYYY.test(value)) {
            return dateFns.parse(value, "MM/dd/yyyy", new Date());
        }
        if (dates_1.reYYYYMMDD.test(value)) {
            return dateFns.parse(value, "yyyy-MM-dd", new Date());
        }
        return undefined;
    }
    throw new Error((0, exports.errMsg)(argPosition, "Date or undefined", value));
};
exports.getArgDateOrUndefined = getArgDateOrUndefined;
const getArgDate = (args, argPosition, context) => {
    const value = (0, exports.getArgUnknown)(args, argPosition, context);
    if (isType.date(value)) {
        return value;
    }
    if (isType.string(value)) {
        if (dates_1.reMMDDYYYY.test(value)) {
            return dateFns.parse(value, "MM/dd/yyyy", new Date());
        }
        if (dates_1.reYYYYMMDD.test(value)) {
            return dateFns.parse(value, "yyyy-MM-dd", new Date());
        }
    }
    throw new Error((0, exports.errMsg)(argPosition, "Date", value));
};
exports.getArgDate = getArgDate;
const getArgArray = (args, argPosition, context) => {
    const value = (0, exports.getArgUnknown)(args, argPosition, context);
    if (isType.array(value)) {
        return value;
    }
    throw new Error((0, exports.errMsg)(argPosition, "array", value));
};
exports.getArgArray = getArgArray;
const getArgMap = (args, argPosition, context) => {
    const value = (0, exports.getArgUnknown)(args, argPosition, context);
    if (value instanceof Map) {
        return value;
    }
    throw new Error((0, exports.errMsg)(argPosition, "Map", value));
};
exports.getArgMap = getArgMap;
//# sourceMappingURL=get-arg.js.map